'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    DATA: {
        INPUT: {
            HORSE_NAME: 'data-diffusion-horsename',
            COURSE_NAME: 'data-diffusion-coursename',
            RACE_TIME: 'data-diffusion-racetime',
            RACE_DATE: 'data-diffusion-racedate',
            BOOKMAKER: 'data-diffusion-bookmaker'
        },
        OUTPUT: {
            OUTCOMERS_ID: 'data-diffusion-outcomers-id',
            FRACTIONAL: 'data-diffusion-fractional',
            DECIMAL: 'data-diffusion-decimal',
            HISTORY: 'data-diffusion-history',
            STATUS: 'data-diffusion-status',
            EVENT_ID: 'data-diffusion-event-id',
            MARKET_ID: 'data-diffusion-market-id',
            MEETING_ID: 'data-diffusion-meeting-id',
            NEXT_PRICE: 'data-diffusion-next-price'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/constants/DIFFUSION.js
// module id = 402
// module chunks = 0